import { CategoryValueXYChart } from '../../../Common/Charts/models/category-value-x-y-chart.model';
import { ReportBlockTypeEnum } from '../enums/report-block-type.enum';
import { DateValueXYChart } from '../../../Common/Charts/models/date-value-x-y-chart.model';
import { PieChart } from '../../../Common/Charts/models/pieChart/pie-chart-new.model';
import { MapChartModel } from '../../../Common/Charts/models/map-chart.model';
import { Am5DateValueXYChart } from '../../../Common/Charts/models/Am5DateValueXYChart/am5-date-value-x-y-chart.model';


export const newDataProcessingWorkflowBlockTypes: ReportBlockTypeEnum[] = [
    ReportBlockTypeEnum.COVERAGE_OVER_TIME,
    ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
    ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME,
    ReportBlockTypeEnum.TOP_10_OUTLETS,
    ReportBlockTypeEnum.TOP_HASHTAGS,
    ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON,
    ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON,
    ReportBlockTypeEnum.SENTIMENT_BREAKDOWN,
    ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN,
    ReportBlockTypeEnum.SHARE_OF_VOICE,
    ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK,
    ReportBlockTypeEnum.COVERAGE_COMPARISON,
    ReportBlockTypeEnum.SENTIMENT_TREND,
    ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS,
    ReportBlockTypeEnum.TOP_REFERRAL_SOURCES,
    ReportBlockTypeEnum.REFERRAL_TREND,
    ReportBlockTypeEnum.COVERAGE_IMPACT_TREND,
    ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME,
    ReportBlockTypeEnum.PROMINENCE_OVER_TIME,
    ReportBlockTypeEnum.COVERAGE_METRIC,
    // MAD Charts
    ReportBlockTypeEnum.SENTIMENT_BY_MEDIA_TYPE,
];

export const newDataProcessingWorkflowChartModelTypes = [
    DateValueXYChart,
    Am5DateValueXYChart,
    CategoryValueXYChart,
    PieChart,
    MapChartModel
];

export const am5BlockTypes = [
    ReportBlockTypeEnum.COVERAGE_OVER_TIME,
    ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
    ReportBlockTypeEnum.SENTIMENT_TREND,
    ReportBlockTypeEnum.COVERAGE_IMPACT_TREND,
    ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME,
    ReportBlockTypeEnum.TOP_10_OUTLETS,
    ReportBlockTypeEnum.TOP_HASHTAGS
];

export const annotatableBlockTypes = [
    ReportBlockTypeEnum.COVERAGE_OVER_TIME,
    ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
    ReportBlockTypeEnum.COVERAGE_IMPACT_TREND,
    ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME,
    ReportBlockTypeEnum.TOP_10_OUTLETS,
    ReportBlockTypeEnum.TOP_HASHTAGS,
    ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS
];

export const briefingAnnotatableBlockTypes = [
    ReportBlockTypeEnum.COVERAGE_OVER_TIME,
    ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
    ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME,
    ReportBlockTypeEnum.TOP_10_OUTLETS,
    ReportBlockTypeEnum.TOP_HASHTAGS
];

